// extracted by mini-css-extract-plugin
export default {"timeRow":"EditQuestionModal_timeRow__ghnK-","timeInput":"EditQuestionModal_timeInput__jyDJU","ml":"EditQuestionModal_ml__Qliql"};